import Component from '../core/Component';

export default class FloatingDots extends Component {

    constructor(element) {
        super(element);

        this.instances = [];
        this.skip = 0;

        this.canvas = document.createElement('canvas');
        this.canvas.style.opacity = 0;
        this.canvasElement = this.element.appendChild(this.canvas);
        this.context = this.canvas.getContext("2d");
    }

    require = async function() {
        const TweenLite = await import('TweenLite');
        await import('CSSPlugin');
        return TweenLite;
    }

    prepare(TweenLite) {
        TweenLite.ticker.addEventListener("tick", ::this.animate);

        // circles num based on window width
        let numCircles = parseInt(window.innerWidth/16);

        // little dots
        let options = {
            opacity: 0.8,
            numCircles: numCircles,
        };
        this.createDots(options);

        // big dots
        let options2 = {
            opacity: 0.02,
            numCircles: numCircles,
            colors: ['rgb(255, 255, 255)'],
            minSize: 10,
            maxSize: 25,
            threeD: true
        };
        this.createDots(options2);

        TweenLite.to(this.canvas, 4, {
            opacity: 1
        });
    }

    createDots(options) {
        const circles = [];

        // SETTINGS
        let o = options.opacity || 0.8
        let c = options.colors || [
                'rgb(243, 181, 78)',
                'rgb(150, 44, 196)',
            ];

        let c2 = []
        c.map(item => {
            let str = item
            str = str.replace('rgb','rgba');
            str = str.split(')');
            item = str[0] + ' ,' + o + ')';
            c2.push(item);
        })

        let
            opacity = o,                                                            // the opacity of the circles 0 to 1
            colors = c2,
            minSize = options.minSize || 1,                                         // the minimum size of the circles in px
            maxSize = options.maxSize || 4,                                         // the maximum size of the circles in px
            numCircles = options.numCircles || 300,                                 // the number of circles
            minSpeed = options.minSpeed || -8,                                      // the minimum speed, recommended: -maxspeed
            maxSpeed = options.maxSpeed || 8,                                       // the maximum speed of the circles
            threeD = options.threeD || false,                                       // the maximum speed of the circles
            expandState = options.expandState || true;                             // the direction of expansion

        let buildArray = () => {
            if (threeD) {
                colors.push(`rgba(0, 255, 200, ${opacity})`);
                colors.push(`rgba(255, 255, 0, ${opacity})`);
            }

            for (var i =0; i < numCircles ; i++){
                var color = Math.floor(Math.random() * (colors.length - 1 + 1)) + 1,
                    left = Math.floor(Math.random() * (this.canvas.width - 0 + 1)) + 0,
                    top = Math.floor(Math.random() * (this.canvas.height - 0 + 1)) + 0,
                    size = Math.floor(Math.random() * (maxSize - minSize + 1)) + minSize,
                    leftSpeed = (Math.floor(Math.random() * (maxSpeed - minSpeed + 1)) + minSpeed)/10,
                    topSpeed = (Math.floor(Math.random() * (maxSpeed - minSpeed + 1)) + minSpeed)/10,
                    expandState = expandState;

                while(leftSpeed == 0 || topSpeed == 0){
                    leftSpeed = (Math.floor(Math.random() * (maxSpeed - minSpeed + 1)) + minSpeed)/10,
                        topSpeed = (Math.floor(Math.random() * (maxSpeed - minSpeed + 1)) + minSpeed)/10;
                }
                var circle = {color:color, left:left, top:top, size:size, leftSpeed:leftSpeed, topSpeed:topSpeed, expandState:expandState };

                if (threeD) {
                    //circles.push(circle);

                    // green
                    let cG = {color: colors.length-1, left:left-3, top:top-2, size:size, leftSpeed:leftSpeed, topSpeed:topSpeed, expandState:expandState };
                    circles.push(cG);
                    // red
                    let cR = {color: colors.length-2, left:left+2, top:top+2, size:size, leftSpeed:leftSpeed, topSpeed:topSpeed, expandState:expandState };
                    circles.push(cR);
                } else {
                    circles.push(circle);
                }
            }
        }

        let build = () => {
            for(var h = 0; h < circles.length; h++){
                var curCircle = circles[h];
                this.context.fillStyle = colors[curCircle.color-1];
                this.context.beginPath();
                if(curCircle.left > this.canvas.width+curCircle.size){
                    curCircle.left = 0-curCircle.size;
                    this.context.arc(curCircle.left, curCircle.top, curCircle.size, 0, 2 * Math.PI, false);
                } else if(curCircle.left < 0-curCircle.size){
                    curCircle.left = this.canvas.width+curCircle.size;
                    this.context.arc(curCircle.left, curCircle.top, curCircle.size, 0, 2 * Math.PI, false);
                } else {
                    curCircle.left = curCircle.left+curCircle.leftSpeed;
                    this.context.arc(curCircle.left, curCircle.top, curCircle.size, 0, 2 * Math.PI, false);
                }

                if(curCircle.top > this.canvas.height+curCircle.size){
                    curCircle.top = 0-curCircle.size;
                    this.context.arc(curCircle.left, curCircle.top, curCircle.size, 0, 2 * Math.PI, false);
                } else if(curCircle.top < 0-curCircle.size) {
                    curCircle.top = this.canvas.height+curCircle.size;
                    this.context.arc(curCircle.left, curCircle.top, curCircle.size, 0, 2 * Math.PI, false);
                } else {
                    curCircle.top = curCircle.top+curCircle.topSpeed;
                    //if(curCircle.size != maxSize && curCircle.size != minSize && curCircle.expandState == false) {
                    //    curCircle.size = curCircle.size-0.1;
                    //}
                    //else if(curCircle.size != maxSize && curCircle.size != minSize && curCircle.expandState == true) {
                    //    curCircle.size = curCircle.size+0.1;
                    //} else if(curCircle.size == maxSize && curCircle.expandState == true) {
                    //    curCircle.expandState = false;
                    //    curCircle.size = curCircle.size-0.1;
                    //} else if(curCircle.size == minSize && curCircle.expandState == false) {
                    //    curCircle.expandState = true;
                    //    curCircle.size = curCircle.size+0.1;
                    //}
                    this.context.arc(curCircle.left, curCircle.top, curCircle.size, 0, 2 * Math.PI, false);
                }

                this.context.closePath();
                this.context.fill();
                this.context.ellipse;
            }
        }

        var xVal = 0;
        let animate = () => {
            // draw the next frame
            xVal++;
            build();
        }

        this.instances.push(animate);

        this.canvas.width = window.innerWidth;
        this.canvas.height = window.innerHeight;

        buildArray();

        window.addEventListener('resize', event => {
            this.canvas.width = window.innerWidth;
            this.canvas.height = window.innerHeight;
        });
    }

    animate() {
        if (this.skip < 3) {
            this.skip++;
        } else {
            this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
            this.instances.forEach(item => {
                item();
            })
            this.skip = 0;
        }

    }

    destroy() {
        TweenLite.ticker.removeEventListener("tick", this.animate);
        window.removeEventListener('resize', event => {
            this.canvas.width = window.innerWidth;
            this.canvas.height = window.innerHeight;
        });
    }
}


// WEBPACK FOOTER //
// ./components/FloatingDots.js